// The week's schedule pivoted by employee, across every store (CJ 2026-10-06:
// "a way of viewing the full weeks schedule by employee"). The All Shifts grid
// is one store at a time, so a person who works two stores shows as two half
// weeks on two screens.
//
// Input: the /api/schedule/:locationKey/week payloads, one per store.
// Output: one row per person with their shifts per day (each tagged with its
// store) and their scheduled hours, plus the open shifts kept separate.

function minutesOf(t) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(t || ''));
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

// Scheduled length in minutes; 0 when either end is missing. A shift ending at
// or before its start is taken to run past midnight.
export function shiftMinutes(s) {
  const a = minutesOf(s.scheduledStart);
  const b = minutesOf(s.scheduledEnd);
  if (a == null || b == null) return 0;
  return b > a ? b - a : b + 24 * 60 - a;
}

export function fmtHours(minutes) {
  const h = Math.round((minutes / 60) * 10) / 10;
  return `${h} h`;
}

export function mergeWeeksByEmployee(weeks) {
  const people = new Map();
  const open = { name: 'Open shifts', isOpen: true, byDay: {}, totalMinutes: 0, shiftCount: 0, stores: [] };
  const dates = new Set();
  for (const w of weeks || []) {
    const store = w?.meta?.locationName || w?.meta?.locationKey || '';
    for (const d of w?.days || []) {
      dates.add(d.date);
      for (const s of d.shifts || []) {
        let row = open;
        if (!s.isOpenShift) {
          // The Square id is the same person at every store; fall back to the
          // Monarch id, then the name, for local-only shifts.
          const key = s.teamMemberId || (s.monarchUserId ? `m:${s.monarchUserId}` : `n:${s.employeeName}`);
          if (!people.has(key)) {
            people.set(key, { key, name: s.employeeName || '(unknown)', role: s.jobTitle || null,
                              byDay: {}, totalMinutes: 0, shiftCount: 0, stores: [] });
          }
          row = people.get(key);
        }
        (row.byDay[d.date] = row.byDay[d.date] || []).push({ ...s, store });
        row.totalMinutes += shiftMinutes(s);
        row.shiftCount += 1;
        if (store && !row.stores.includes(store)) row.stores.push(store);
      }
    }
  }
  const byStart = (a, b) => (minutesOf(a.scheduledStart) ?? 1e9) - (minutesOf(b.scheduledStart) ?? 1e9);
  const rows = [...people.values()].sort((a, b) => a.name.localeCompare(b.name));
  for (const r of [...rows, open]) for (const ymd of Object.keys(r.byDay)) r.byDay[ymd].sort(byStart);
  return { days: [...dates].sort(), people: rows, open: open.shiftCount > 0 ? open : null };
}
